/* GSF Box Builder — 2026-09-08
   Escalier de paliers sur des pochettes a l'unite, avec raccourcis.

   🔴 ARRONDI : Shopify applique le rabais A L'UNITE et arrondit VERS LE BAS au
   cent. 8,49 $ a 10 % donne 0,84 $ de rabais (pas 0,849), donc 7,65 $. Calculer
   le rabais sur le total puis diviser donne 7,641 $ et le prix affiche ne
   correspond plus au panier. Toute la section utilise `unitAfter()`.

   🔴 RACCOURCIS : une boite de 8 demande 9 gestes a la main (8 taps sur + puis
   le bouton), une boite de 15 en demande 16. L'ancien coffret en demandait 2.
   `fillBox()` ramene a 2, et le client peut encore ajuster ensuite. */

(function () {
  'use strict';

  function formatMoney(cents, format) {
    var value = (cents / 100);
    var fmt = format || '${{amount}}';
    function withComma(n) { return n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
    function noDecimals(n) { return Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
    return fmt
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, noDecimals(value))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, withComma(value).replace(/,/g, ' ').replace('.', ','))
      .replace(/\{\{\s*amount\s*\}\}/g, withComma(value));
  }

  function fill(tpl, tokens) {
    return Object.keys(tokens).reduce(function (out, k) {
      return out.split('[' + k + ']').join(tokens[k]);
    }, tpl || '');
  }

  function unitAfter(priceCents, pct) {
    if (!pct) return priceCents;
    return priceCents - Math.floor(priceCents * pct / 100);
  }

  function init(root) {
    if (root.dataset.gsfReady === '1') return;
    root.dataset.gsfReady = '1';

    var cfgEl = root.querySelector('[data-gsf-config]');
    if (!cfgEl) return;
    var cfg;
    try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }

    var tiers = (cfg.tiers || [])
      .filter(function (t) { return t && Number(t.qty) > 0; })
      .sort(function (a, b) { return a.qty - b.qty; });

    var cards     = Array.prototype.slice.call(root.querySelectorAll('[data-gsf-card]'));
    var stepEls   = Array.prototype.slice.call(root.querySelectorAll('[data-gsf-step]'));
    var presetEls = Array.prototype.slice.call(root.querySelectorAll('[data-gsf-preset]'));
    var clearEl   = root.querySelector('[data-gsf-clear]');
    var fillEls   = Array.prototype.slice.call(root.querySelectorAll('[data-gsf-fill]'));
    /* La piste de reference pour calculer la position des paliers est celle du HAUT,
       celle qui porte les etapes. C'est la premiere du DOM. La mini du bandeau
       collant ne sert qu'a l'affichage. */
    var trackEl   = fillEls[0] ? fillEls[0].parentElement : null;
    var nudgeEls  = Array.prototype.slice.call(root.querySelectorAll('[data-gsf-nudge]'));
    var countEl   = root.querySelector('[data-gsf-count]');
    var unitEl    = root.querySelector('[data-gsf-unit]');
    var wasEl     = root.querySelector('[data-gsf-was]');
    var nowEl     = root.querySelector('[data-gsf-now]');
    var eachEl    = root.querySelector('[data-gsf-each]');
    var ctaEl     = root.querySelector('[data-gsf-add]');
    var errEl     = root.querySelector('[data-gsf-error]');

    /* Seules les pochettes en stock portent un bouton +. */
    var buyable = cards.filter(function (c) { return c.querySelector('[data-gsf-plus]'); });

    var state = {};

    function grossTotals() {
      var qty = 0, cents = 0;
      cards.forEach(function (card) {
        var n = state[card.dataset.vid] || 0;
        qty += n;
        cents += n * Number(card.dataset.price || 0);
      });
      return { qty: qty, cents: cents };
    }
    function effectiveTotal(pct) {
      var c = 0;
      cards.forEach(function (card) {
        var n = state[card.dataset.vid] || 0;
        c += n * unitAfter(Number(card.dataset.price || 0), pct);
      });
      return c;
    }
    function currentTier(qty) {
      var found = null;
      tiers.forEach(function (t) { if (qty >= t.qty) found = t; });
      return found;
    }
    function nextTier(qty) {
      for (var i = 0; i < tiers.length; i++) { if (qty < tiers[i].qty) return tiers[i]; }
      return null;
    }

    /* Repartition a parts egales, le reste allant aux premieres saveurs.
       8 sur 6 saveurs donne 2, 2, 1, 1, 1, 1. */
    function fillBox(total) {
      if (!buyable.length || !total) return;
      state = {};
      var base = Math.floor(total / buyable.length);
      var reste = total % buyable.length;
      buyable.forEach(function (c, i) {
        state[c.dataset.vid] = base + (i < reste ? 1 : 0);
      });
      render();
    }

    function centerOf(i) {
      if (!trackEl || !stepEls[i]) return 0;
      var tr = trackEl.getBoundingClientRect();
      if (!tr.width) return 0;
      var sr = stepEls[i].getBoundingClientRect();
      return Math.max(0, Math.min(100, ((sr.left + sr.width / 2) - tr.left) / tr.width * 100));
    }
    function progressPercent(qty) {
      if (!stepEls.length || !trackEl || !tiers.length) return 0;
      if (qty <= 0) return 0;
      if (qty < tiers[0].qty) return centerOf(0) * (qty / tiers[0].qty);
      for (var i = 0; i < tiers.length - 1; i++) {
        if (qty >= tiers[i].qty && qty < tiers[i + 1].qty) {
          var span = tiers[i + 1].qty - tiers[i].qty;
          var frac = span > 0 ? (qty - tiers[i].qty) / span : 0;
          return centerOf(i) + (centerOf(i + 1) - centerOf(i)) * frac;
        }
      }
      return 100;
    }

    function render() {
      var t = grossTotals();
      var tier = currentTier(t.qty);
      var pct = tier ? Number(tier.discount || 0) : 0;
      var next = nextTier(t.qty);
      var effective = (tier && Number(tier.amountOffCents) > 0)
        ? Math.max(0, t.cents - Number(tier.amountOffCents))
        : effectiveTotal(pct);
      var unitWord = t.qty === 1 ? cfg.unitSingular : cfg.unitPlural;

      cards.forEach(function (card) {
        var n = state[card.dataset.vid] || 0;
        var qEl = card.querySelector('[data-gsf-qty]');
        var bEl = card.querySelector('[data-gsf-badge]');
        var mEl = card.querySelector('[data-gsf-minus]');
        if (qEl) qEl.textContent = n;
        if (bEl) { bEl.textContent = n; bEl.hidden = n === 0; }
        if (mEl) mEl.disabled = n === 0;

        var full = Number(card.dataset.price || 0);
        var eff = unitAfter(full, pct);
        var wrap = card.querySelector('[data-gsf-price]');
        var pWas = card.querySelector('[data-gsf-price-was]');
        var pNow = card.querySelector('[data-gsf-price-now]');
        var enPromo = pct > 0 && eff < full;
        if (wrap) wrap.classList.toggle('is-sale', enPromo);
        if (pWas) { pWas.hidden = !enPromo; pWas.textContent = formatMoney(full, cfg.moneyFormat); }
        if (pNow) pNow.textContent = formatMoney(eff, cfg.moneyFormat);
      });

      stepEls.forEach(function (el) {
        el.classList.toggle('is-reached', t.qty >= Number(el.dataset.qty || 0));
      });
      var pct = progressPercent(t.qty).toFixed(2) + '%';
      fillEls.forEach(function (el) { el.style.width = pct; });

      presetEls.forEach(function (b) {
        b.classList.toggle('is-active', Number(b.dataset.gsfPreset) === t.qty);
      });
      if (clearEl) clearEl.hidden = t.qty === 0;

      var nudgeText;
      {
        if (t.qty === 0 && cfg.emptyMessage) {
          nudgeText = fill(cfg.emptyMessage, {
            n: tiers[0] ? tiers[0].qty : 1,
            unit: cfg.unitPlural,
            free: tiers[1] ? tiers[1].qty : ''
          });
        } else if (next) {
          var missing = next.qty - t.qty;
          var isFirstTier = tiers.length > 0 && next.qty === tiers[0].qty;
          var tpl = (isFirstTier && cfg.nudgeMinimum) ? cfg.nudgeMinimum : cfg.nudgeTemplate;
          nudgeText = fill(tpl, {
            n: missing,
            unit: missing === 1 ? cfg.unitSingular : cfg.unitPlural,
            reward: next.label
          });
        } else {
          nudgeText = t.qty > 0 ? (cfg.maxedMessage || '') : '';
        }
      }
      nudgeEls.forEach(function (el) { el.textContent = nudgeText; });

      if (countEl) countEl.textContent = t.qty;
      if (unitEl) unitEl.textContent = unitWord;
      if (nowEl) nowEl.textContent = formatMoney(effective, cfg.moneyFormat);
      if (wasEl) {
        wasEl.hidden = effective >= t.cents || t.qty === 0;
        wasEl.textContent = formatMoney(t.cents, cfg.moneyFormat);
      }
      if (eachEl) {
        eachEl.textContent = t.qty > 0
          ? fill(cfg.eachTemplate, { price: formatMoney(Math.round(effective / t.qty), cfg.moneyFormat) })
          : '';
      }

      if (ctaEl) {
        var minQty = tiers[0] ? tiers[0].qty : 1;
        if (t.qty < minQty) {
          var need = minQty - t.qty;
          ctaEl.disabled = true;
          ctaEl.textContent = fill(ctaEl.dataset.labelNeed, {
            n: need, unit: need === 1 ? cfg.unitSingular : cfg.unitPlural
          });
        } else {
          ctaEl.disabled = false;
          ctaEl.textContent = ctaEl.dataset.labelAdd;
        }
      }
    }

    presetEls.forEach(function (btn) {
      btn.addEventListener('click', function () {
        fillBox(Number(btn.dataset.gsfPreset) || 0);
      });
    });
    if (clearEl) clearEl.addEventListener('click', function () { state = {}; render(); });

    cards.forEach(function (card) {
      var vid = card.dataset.vid;
      var plus = card.querySelector('[data-gsf-plus]');
      var minus = card.querySelector('[data-gsf-minus]');
      if (plus) plus.addEventListener('click', function () {
        state[vid] = (state[vid] || 0) + 1; render();
      });
      if (minus) minus.addEventListener('click', function () {
        state[vid] = Math.max(0, (state[vid] || 0) - 1); render();
      });
    });

    if (ctaEl) ctaEl.addEventListener('click', function () {
      var items = cards
        .filter(function (c) { return (state[c.dataset.vid] || 0) > 0; })
        .map(function (c) { return { id: Number(c.dataset.vid), quantity: state[c.dataset.vid] }; });
      if (!items.length) return;

      ctaEl.classList.add('is-loading');
      ctaEl.disabled = true;
      if (errEl) errEl.hidden = true;

      var root_url = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(root_url + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
        .then(function () {
          /* 2026-09-09 : le bouton quittait TOUJOURS la page. Il ouvre desormais
             le tiroir panier du theme, sans navigation. `checkout` et `cart`
             restent disponibles dans les reglages de la section.
             Le `root_url` s'applique aussi au checkout : sans lui, un visiteur
             en /fr/ etait renvoye vers la version anglaise. */
          if (cfg.redirect === 'checkout') { window.location.href = root_url + 'checkout'; return; }
          if (cfg.redirect === 'cart') { window.location.href = root_url + 'cart'; return; }

          if (window.eventBus && window.eventBus.emit) {
            /* La boite est au panier : on repart d'une boite vide, sinon un
               second clic commanderait le tout en double. */
            state = {};
            render();
            ctaEl.classList.remove('is-loading');
            ctaEl.disabled = false;
            window.eventBus.emit('render:cart:drawer');
            window.eventBus.emit('open:cart:drawer', { scrollToTop: true });
            return;
          }
          window.location.href = root_url + 'cart';
        })
        .catch(function () {
          ctaEl.classList.remove('is-loading');
          ctaEl.disabled = false;
          if (errEl) { errEl.textContent = cfg.errorMessage || 'Something went wrong.'; errEl.hidden = false; }
        });
    });

    window.addEventListener('resize', render);
    if (document.fonts && document.fonts.ready) { document.fonts.ready.then(render); }
    render();
  }

  function boot() { document.querySelectorAll('[data-gsf-box-builder]').forEach(init); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }
  document.addEventListener('shopify:section:load', boot);
})();
